import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const FullHeightDropDown = ({ label, Links }) => (
  <div className="Navbar__FullHeightDropDown">
    <p>{label}</p>
    <div className="Navbar__FullHeightDropDownTriggerZone">
      <div className="Navbar__FullHeightDropDownItems">{Links}</div>
    </div>
  </div>
);

FullHeightDropDown.propTypes = {
  label: PropTypes.string.isRequired,
  Links: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default FullHeightDropDown;
